import { render, staticRenderFns } from "./SelectImgDialog.vue?vue&type=template&id=24b418b8&scoped=true"
import script from "./SelectImgDialog.vue?vue&type=script&lang=js"
export * from "./SelectImgDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectImgDialog.vue?vue&type=style&index=0&id=24b418b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b418b8",
  null
  
)

export default component.exports